export default __webpack_public_path__ + "static/media/CLICHY (87 sur 176).4f27ecf8.jpg";